module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wechat-wrap"
  }, [_c('cIndex', {
    ref: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "payWeChat-content"
  }, [_c('h2', [_vm._v("正在使用即时交易，30分钟后交易关闭")]), _vm._v(" "), _c('ul', {
    staticClass: "payWechat-transaction"
  }, [_c('li', [_vm._v("脑能力测评订单-"), _c('b', [_vm._v(_vm._s(_vm.payName))]), _vm._v("，共"), _c('b', [_vm._v(_vm._s(_vm.payPprice))]), _vm._v("元 ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', [_vm._v("订单号："), _c('b', [_vm._v(_vm._s(_vm.ordernumberpay))])])]), _vm._v(" "), _c('p', [_vm._v("应付金额"), _c('span', {
    staticClass: "payMoneyY"
  }, [_vm._v(_vm._s(_vm.payPprice))]), _vm._v("元")]), _vm._v(" "), _c('ul', {
    staticClass: "wechart-money"
  }, [_c('li', [_c('div', {
    staticClass: "wechat-border"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgSrc
    }
  })]), _c('span', {
    staticClass: "wechat-Message"
  }, [_vm._v("请使用微信扫一扫，扫描二维码支付")])]), _vm._v(" "), _vm._m(1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_vm._v("收款方："), _c('b', [_vm._v("北京智精灵科技有限公司")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('img', {
    staticClass: "phonelOGO",
    attrs: {
      "src": require("../assets/weChatLogo.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e2570d8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payWeChat.vue
// module id = 766
// module chunks = 1